import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconUpload = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.3691C2.41421 12.3691 2.75 12.7049 2.75 13.1191C2.75 13.4885 2.89674 13.8428 3.15798 14.104L3.15798 14.104C3.41917 14.3653 3.77344 14.512 4.14286 14.512L11.6429 14.512C12.0122 14.512 12.3665 14.3653 12.6277 14.104C12.889 13.8428 13.0357 13.4885 13.0357 13.1191C13.0357 12.7049 13.3715 12.3691 13.7857 12.3691C14.1999 12.3691 14.5357 12.7049 14.5357 13.1191C14.5357 13.8863 14.2309 14.6221 13.6884 15.1647C13.1459 15.7072 12.4101 16.012 11.6429 16.012H4.14286C3.37564 16.012 2.63981 15.7072 2.09729 15.1647C1.55479 14.6221 1.25 13.8864 1.25 13.1191C1.25 12.7049 1.58579 12.3691 2 12.3691Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36254 0.803166C7.65543 0.510273 8.1303 0.510273 8.4232 0.803166L11.1018 3.48174C11.3947 3.77463 11.3947 4.2495 11.1018 4.5424C10.8089 4.83529 10.334 4.83529 10.0411 4.5424L7.89287 2.39416L5.74462 4.5424C5.45173 4.83529 4.97686 4.83529 4.68396 4.5424C4.39107 4.2495 4.39107 3.77463 4.68396 3.48174L7.36254 0.803166Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89288 0.583496C8.3071 0.583496 8.64288 0.919283 8.64288 1.3335L8.64288 10.9764C8.64288 11.3906 8.3071 11.7264 7.89288 11.7264C7.47867 11.7264 7.14288 11.3906 7.14288 10.9764L7.14288 1.3335C7.14288 0.919283 7.47867 0.583496 7.89288 0.583496Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
